import { render, staticRenderFns } from "./FreetextQuestion.vue?vue&type=template&id=567fb458&"
import script from "./FreetextQuestion.vue?vue&type=script&lang=js&"
export * from "./FreetextQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FreetextQuestion.vue?vue&type=style&index=0&id=567fb458&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports